export default "__VITE_ASSET__Drgbuc$p__"